/* eslint-disable @typescript-eslint/no-explicit-any */
// Type guards for PDF.js objects
export interface PDFRenderTask {
  cancel: () => void
  promise: Promise<void>
}

export interface PDFLoadingTask {
  destroy: () => void
  docId: string
}

export interface PDFDocument {
  loadingTask: PDFLoadingTask
  _transport?: {
    pageCache?: Record<number, any>
  }
}

export const isPDFRenderTask = (obj: unknown): obj is PDFRenderTask => {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    'cancel' in obj &&
    typeof (obj as any).cancel === 'function'
  )
}

export const isPDFLoadingTask = (obj: unknown): obj is PDFLoadingTask => {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    'destroy' in obj &&
    typeof (obj as any).destroy === 'function'
  )
}

export const isPDFDocument = (obj: unknown): obj is PDFDocument => {
  return obj !== null && typeof obj === 'object' && 'loadingTask' in obj
}
